import { action, makeAutoObservable } from 'mobx'

export type ImageState = 'none' | 'success' | 'error'

export class ImageStore {
  readonly source: string
  state: ImageState = 'none'

  constructor(source: string) {
    makeAutoObservable(this)
    this.source = source
    void this.load()
  }

  private async load() {
    const img = document.createElement('img')
    img.src = this.source
    img.style.display = 'none'
    img.addEventListener('load', action(() => this.state = 'success'))
    img.addEventListener('error', action(() => this.state = 'error'))
    document.body.append(img)
  }
}
